import { Component, OnInit, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter }  from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { Extra } from '@app/modules/model/extra';

import { languageSupport, languageService } from '@app/modules/common/language'
import { viewService } from '@app/modules/view';

@Component({
    selector: 'ui-extra-thumbnail',
    templateUrl:'./ui-thumb.html',
    styleUrls: [ 
        './ui-thumb.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiExtraThumbnail extends languageSupport implements OnInit, OnDestroy {
    @Input('extra') _extra: Extra = null;

    private _subscriptions = [];

    /***********************************/
    /* STARTS HERE                     */
    /***********************************/

    constructor(private lang: languageService, private change: ChangeDetectorRef, public view: viewService) {
        super(lang, change);
    }

    ngOnInit(){
        if (this._extra){
            // refresh on extra changed
            this._subscriptions.push(
                this._extra.OnRefresh.subscribe(
                data => {
                    this.change.markForCheck();
                })
            );    

            // refresh on theme changed
            this._subscriptions.push(
                this.view.OnTheme.subscribe(
                data => {
                    this.change.markForCheck();
                })
            );
        }
    }

    ngOnDestroy(){
        super.OnDestroy();

        for(let _subscription of this._subscriptions){
            _subscription.unsubscribe();
        }
        this._subscriptions = [];
    }

    /***********************************/
    /* EVENT HANDLERS                  */
    /***********************************/

    @Output('onSelect') _onSelect = new EventEmitter<any>();         
    OnSelect(){
        this._onSelect.emit(this._extra);
    }
}
